/** Pre-order shipping date, which is in past  */
export const PRE_ORDER_SHIPPING_DATE = 'Oktober 2020';
